import { trackAddToCart } from '../lib/metaPixel'

export const CHECKOUT_URL =
  'https://controltotalhoy.com/checkouts/cn/hWNDXYlauXJR6D4MnehD55TV/es-ar?_r=AQABQwphSLnXVkmNzwFLhDCFMIQk9BB1itRIltd57IzNM1c&cart_link_id=pxqiuVGJ&preview_theme_id=164125278448'

export function goToCheckout() {
  // Fire the Meta Pixel AddToCart event the moment the user commits to buying,
  // before sending them to the Shopify checkout.
  trackAddToCart()

  // Open the checkout in a new tab so the current page (and the editor preview)
  // stays mounted instead of navigating away / "disconnecting".
  window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer')
}
